export const PopupStates = {
    DEFAULT: 'default',
    SUCCESS: 'success',
    ERROR: 'error'
};

export const PopupTypes = {
    NONE: '',
    SAVE: 'save',
    PUBLISH: 'publish',
    NOWEBGL: 'noWebGL',
    FAILEDLOAD: 'failedLoad',
    LEVEL_SETTINGS: 'levelSettings',
    LEVEL_REMOVE_WARNING: 'levelRemoveWarning'
};
